<template>
  <div class="room">
    <div class="title h-outer-border around-4 h-bg blue-2">
      {{roomInfo.name}} ({{DRAFT_MODE_NAME[roomInfo.draftMode]}})
    </div>

    <div class="team-list">
      <div class="team-panel h-outer-border around-4 h-bg blue-2 bz0"
           v-for="(team, index) in roomInfo.teams"
           :key="'team-' + team.id">
        <div class="team-header h-outer-border around-4 bw2">
          队伍{{ index + 1 }}
        </div>
        <RoomMember v-for="(player, i) in team.players"
                    :key="team.id + i"
                    :flag="(index * team.maxPlayersNum + i + 1)"
                    :player="player || {}"
                    @alert="alert"
                    @addAI="handleShowDifficultyPopup(team.id, i)"
                    @removeAI="handleRemoveAIPlayer(team.id, player)"
                    @showFreeConfigPopup="handleShowModeFreePopup"
                    @showRolePopup="handleShowModeRolePopup"
                    @click.native="handleChangeTeam(team, team.players[i], i)">
        </RoomMember>
      </div>

      <!-- 观众 -->
      <div v-for="spectator in spectators" :key="spectator.id"
           class="room-member-item h-outer-border around-4 h-bg blue-2">
        <div class="side">
          <div class="h-tag">
            <div>观战</div>
          </div>
        </div>
        <div class="nick sep-border-left">{{ spectator.nick }}</div>
      </div>

      <div class="in-room-buttons">
        <button v-show="!isSpectator"
                v-click-sound-button
                type="button"
                class="prepare h-button normal"
                :disabled="prepareDisable"
                @click="prepareHandler">准备
        </button>
        <button v-click-sound-button
                type="button"
                class="btn-exit h-button normal"
                :disabled="exitDisable"
                @click="exitRoomHandler">离开
        </button>
      </div>

      <div class="config-panel">
        <!-- 已选择 -->
        <div v-if="roomInfo.draftMode === 1 && roleInfo" class="selected-hero">
          <div class="hero-avatar h-outer-border around-4 bw3 bz0">
            <img :src="roleInfo.avatar" alt="">
          </div>
          <div class="hero-name h-outer-border around-4 bw3 bz0 h-bg blue-2">
            {{ roleInfo.nameCn }}
            <div class="corner-tag h-outer-border around-4 bw2 bz0">已选择</div>
          </div>
        </div>
        <!-- 已配置 -->
        <div v-if="roomInfo.draftMode === 2 && freeConfig"
             class="selected-config h-bg blue-2">
          <div class="nick h-outer-border around-4 bw3 bz0">
            {{ self.nick }}
          </div>
          <div class="config-name h-outer-border around-4 bw3 bz0">
            {{ freeConfig.title || '' }}
          </div>
          <div class="corner-tag h-outer-border around-4 bw2 bz0">已选择</div>
        </div>
        <!-- AI已配置 -->
        <!--<div v-if="roomInfo.draftMode === 2 && AIFreeConfig"
             class="selected-config h-bg blue-2">
          <div class="nick h-outer-border around-4 bw3 bz0">
            简单的电脑
          </div>
          <div class="config-name h-outer-border around-4 bw3 bz0">
            {{ AIFreeConfig.title || '' }}
          </div>
          <div class="corner-tag h-outer-border around-4 bw2 bz0">已选择</div>
        </div>-->
      </div>

    </div>

    <div v-if="roomInfo.pvpBounty"
         class="pvp-bounty-info h-outer-border around-4 h-bg blue-2 bz0">
      PVP悬赏金：{{ roomInfo.pvpBounty }}
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import AudioCtrl from '@js/audio-ctrl'
  import RoomMember from './room-member'
  import { TP as AudioTP, getSoundEffectUrl } from '@js/config/audio/common'

  const PLAYER_STATUS = {
    0: '未准备',
    1: '已准备',
  }

  const DRAFT_MODE_NAME = {
    0: '标准竞技',
    1: '角色竞技',
    2: '自由竞技',
  }

  export default {
    data () {
      return {
        PLAYER_STATUS,
        DRAFT_MODE_NAME,
        roleInfo: null,
        exitDisable: false,
        freeConfig: null,
        AIFreeConfig: null,
        isConfigAI: false,
      }
    },

    computed: {
      ...mapGetters('user', [
        'userInfo',
      ]),
      ...mapGetters('hero', [
        'actionPoint',
      ]),

      ...mapGetters('gameSocket', [
        'roomList',
        'roomInfo',
      ]),

      prepareDisable () {
        return this.isSpectator
          || this.self.status !== 0
          || (this.roomInfo.draftMode === 1 && !this.roleInfo)
          || (this.roomInfo.draftMode === 2 && !this.freeConfig)
      },

      isSpectator () {
        return this.roomInfo.spectators.some((p) => {
          return p.userId === this.userInfo.id
        })
      },

      owner () {
        return this.roomInfo.players[0] || {}
      },

      isOwner () {
        return this.roomInfo.ownerUID === this.userInfo.id
      },

      players () {
        return this.roomInfo.players || []
      },

      member () {
        return this.roomInfo.players[1] || {}
      },

      spectators () {
        return this.roomInfo.spectators || []
      },

      self () {
        return this.roomInfo && this.roomInfo.players.find(p => {
          return p.userId === this.userInfo.id
        }) || {}
      }
    },

    watch: {
      players (val, oldVal) {
        const newNum = val.length
        const oldNum = oldVal.length
        // 进入房间
        if (newNum > oldNum && !this.member.isAI) {
          AudioCtrl.play({ url: getSoundEffectUrl(AudioTP.PLAYCOME) })
        }
      }
    },

    mounted () {
      if (!this.isOwner) {
        this.exitDisable = true
        setTimeout(() => {
          this.exitDisable = false
        }, 1000)
      }
    },

    methods: {
      ...mapActions('gameSocket', [
        'exitRoom',
        'prepare',
        'addAIPlayer',
        'removeAIPlayer',
        'changeTeam',
        'updateAIFreeModeConfig',
      ]),

      handleShowModeRolePopup () {
        this.$emit('showRoleModePopup')
      },

      handleShowModeFreePopup (isAI) {
        this.$emit('showFreeModePopup', isAI)
        this.isConfigAI = isAI
      },

      handleModeRoleSelect (data) {
        this.roleInfo = JSON.parse(JSON.stringify(data))
      },

      handleModeFreeSelect (data) {
        console.log('handleModeFreeSelect', this.freeConfig)
        if (this.isConfigAI) {
          this.AIFreeConfig = JSON.parse(JSON.stringify(data))
          this.updateAIFreeModeConfig(JSON.parse(JSON.stringify(data)))
        } else {
          this.freeConfig = JSON.parse(JSON.stringify(data))
        }
      },

      // 离开房间
      exitRoomHandler () {
        this.exitRoom({ roomId: this.roomInfo.id })
      },

      // 准备
      prepareHandler () {
        if (this.actionPoint <= 0) {
          this.$message('行动力不足')
          return
        }

        let data = null
        if (this.roomInfo.draftMode === 1) {
          data = {
            nameCn: this.roleInfo.nameCn,
            troop: this.roleInfo.troop,
          }
        } else if (this.roomInfo.draftMode === 2) {
          // 自由竞技
          data = {
            ps: this.freeConfig.ps,
            ss: this.freeConfig.ss,
            sp: this.freeConfig.sp,
            tr: this.freeConfig.tr,
          }
        }
        // console.log('[prepare]', data)
        this.prepare(data)
      },

      alert (message) {
        this.$emit('alert', message)
      },

      // 显示电脑难度选择
      handleShowDifficultyPopup (teamId, index) {
        if (this.roomInfo.draftMode === 1) {
          this.addAIPlayer({ AIDifficulty: 1, AIVersion: 2, teamId, index })
          return
        }
        // 自由竞技
        if (this.roomInfo.draftMode === 2) {
          this.addAIPlayer({ AIDifficulty: 1, AIVersion: 2, teamId, index })
          return
        }
        this.$emit('showDifficultyPopup', { teamId, index })
      },

      // 移除AI
      handleRemoveAIPlayer (teamId, player) {
        if (this.isSpectator) {
          return
        }
        this.removeAIPlayer({ teamId, playerId: player.id })
      },

      // 暂不开放
      handleChangeTeam (team, player, index) {
        // if (this.isSpectator) {
        //   return
        // }
        // if (player?.id) {
        //   return
        // }
        // this.changeTeam({ teamId: team.id, index })
      },

    },

    components: {
      RoomMember,
    }
  }
</script>

<style lang="stylus" scoped>
  .room
    height 100%

  .pvp-bounty-info
    position absolute
    left 0
    bottom 0
    width 100%
    padding 10px 0
    text-align center
    font-size 14px
    letter-spacing 1px
    goldText1()

  .team-panel
    padding 5px
    &:not(:last-child)
      margin-bottom 5px
    .team-header
      margin-bottom 5px
      padding 2px
      line-height 30px
      font-size 14px
      text-indent 5px
      text-align center
      whiteText1()

  .config-panel
    margin-top 20px

  .selected-hero,
  .selected-config
    position relative
    overflow hidden
    display flex
    margin-bottom 5px
    .hero-avatar
      width 60px
      padding 3px
      img
        max-width 100%
        vertical-align middle
    .hero-name
      position relative
      display flex
      justify-content center
      align-items center
      flex-grow 1
      margin-left 1px
      letter-spacing 2px
      goldText1()
      &:before
        z-index 5 !important
    .corner-tag
      position absolute
      z-index 0
      top 10px
      right -25px
      width 90px
      padding 1px
      line-height 22px
      vertical-align middle
      font-size 12px
      text-align center
      transform-origin center
      transform rotate(45deg)
      letter-spacing 1px
      color #fff
      background-color $colorGreen1

  .selected-config
    height 60px
    .nick
      display flex
      justify-content center
      align-items center
      width 80px
      font-size 12px
      goldText1()
    .config-name
      display flex
      justify-content center
      align-items center
      width calc(100% - 80px)
      padding 2px 30px 2px 10px
      line-height 16px
      font-size 12px
      letter-spacing 2px
      whiteText1()
    > .corner-tag
      top 5px
      right -30px
      transform rotate(45deg) scale(0.8)

  .room
    > .title
      margin-bottom -1px
      goldText()
      line-height 36px
      font-size 16px
      text-align center
      letter-spacing 1px
      &:before
        z-index 0 !important
        border-width 2px

  // 房间内成员
  .team-list
    margin-top 5px
    padding-top 2px
    .room-member-item
      display flex
      margin-top -3px
      padding 4px
      height 40px
      line-height 32px
      font-size 12px
      color #fff
      &:before
        z-index 0 !important
      > div
        position relative
        text-align center
      .side
        display flex
        justify-content center
        align-items center
        width 30px
        .side-icon
          width 24px
          height 29px
          background-repeat no-repeat
          background-size 100%
          &.red
            background-image uiURL("VWSYMT0L.png")
          &.blue
            background-image uiURL("VWSYMT1G.png")
      .nick
        width calc(100% - 110px)
        padding 0 10px
      .prepare-status
        display flex
        align-items center
        justify-content center
        width 80px
        color $colorRed1
        text-shadow 1px 1px 1px #000
        &.already
          color $colorGreen
          text-shadow 1px 1px 1px #000
        .ai-btn-field
          padding-left 3px
          height 100%
          display flex
          justify-content center
          align-items center
        .btn-show-ai-difficulty p
          letter-spacing 0
          transform scale(0.833)

  .in-room-buttons
    margin-top 10px
    font-size 12px
    text-align right
    .h-button
      margin 0 2px
      width 60px
      height 28px
      background-size 60px 56px
      line-height 28px
      font-size 12px
      letter-spacing 1px
      color #f8e490
      text-shadow 2px 2px 1px #000
      &:disabled
        color #777
      &:active
        background-position 0 -28px

  .remove-btn
    z-index 1
    margin-left 10px
    width 14px
    height 14px
    border 1px solid #78624a
    border-radius 2px
    line-height 12px
    text-align center
    font-size 14px
    background-color #392519
    user-select none
    goldText1()
    &:hover
      cursor pointer
      border-color lighten(#78624a, 10%)
      color darken($colorGold, 30%)

</style>
